import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const MakeDefaults = {
  webhook_url: "",
};

const WEBHOOK_URL_REGEX = /^https:\/\/[^/]*\.make\.com\//i;

export const MakeShape = {
  webhook_url: Yup.string()
    .label("Webhook URL")
    .required()
    .max(500)
    .matches(WEBHOOK_URL_REGEX, "Must be a make.com webhook URL (e.g. https://hook.eu1.make.com/…)."),
};

export interface MakeInput {
  webhook_url: string;
}

yupResolver<MakeInput>(Yup.object().shape(MakeShape));
